export default (function() {
    $('#mobile-menu .mobile-menu-main .menu-item-has-children').append('<div class="open-btn"></div>');
    $('#menu-go-back').click(function() {
      let subMenu = document.getElementById('mobile-menu');
      let target = deepest(subMenu, '.active');
      $(target).removeClass('active');
      let level = deepest(subMenu, '.active');
      if(subMenu == level) {
        $('#menu-go-back').removeClass('show');
      }
    });
    $('#mobile-menu .mobile-menu-main .menu-item-has-children').click(function(){
      $('#menu-go-back').addClass('show');
      $(this).find('.sub-menu:first').addClass('active');
    });
    $('#mobile-menu .mobile-menu-main .menu-item a').click(function(e){
      if ($(this).attr('href').indexOf('#') > -1) {
        $('.mobile-menu').toggleClass('show');
      }
    });
})();

export function mobile_menu_toggle_btn() {
  $("#burger-menu-open").click(function() {
    $('.mobile-menu').toggleClass('show');
  });
  $("#burger-menu-close").click(function(){
    $('.mobile-menu').toggleClass('show');
  });
}

export function mobile_language_selector() {
  if($('#lang_selector_mobile').length) {
    $('#lang_selector_mobile').click(function() {
      if($('#language_selector_drop_down_mobile').hasClass('open')) {
        $('#language_selector_drop_down_mobile').slideUp();
        $('#language_selector_drop_down_mobile').removeClass('open');
      } else {
        $('#language_selector_drop_down_mobile').slideDown();
        $('#language_selector_drop_down_mobile').addClass('open');
      }
    });
  }
}

function deepest (subMenu, select) {
  return [].slice.call (subMenu.querySelectorAll (select)).reduce (
    function (deepest, el) {
      for (var d = 0, e = el; e !== subMenu; d++, e = e.parentNode);
      return d > deepest.d ? {d: d, el: el} : deepest;
    }, {d: 0, el: subMenu}).el;
 }
